export const countTravelersFromRooms = (rooms) => {
  if (!!rooms && rooms.length > 0) {
    return rooms.reduce((accumulator, room) => {
      const { adults = 0, children = [], infants = [] } = room;

      return accumulator + adults + children.length + infants.length;
    }, 0);
  }

  return 0;
};
